import React from "react"
import Layout from "../components/layout"
import pageStyles from "../styles/modules/pages.module.scss"
import { Link, graphql } from "gatsby"
import { FaArrowLeft } from "react-icons/fa"
import Footer from "../components/footer"

const Post = ({ data }) => {
  const info = data.markdownRemark.frontmatter
  return (
    <Layout>
      <div className={pageStyles.template}>
        <Link className={pageStyles.blogBack} style={{ color: "rgb(8, 132, 214)" }} to="/blogs">
          <FaArrowLeft style={{ marginRight: "5px", marginBottom: "3px" }} />
          Go back to all blogs
        </Link>
        <h1>{info.title}</h1>
        <h6> Created on {info.date}</h6>
        <h6> By {info.author}</h6>
        <hr />
        <br />
        <div
          dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}
        ></div>
      </div>
      <Footer />
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        date
        title
        author
      }
      timeToRead
      html
    }
  }
`

export default Post
